export default __webpack_public_path__ + "static/media/dep1_6-3.b8a6572a.png";